<app-loading *ngIf="contentReady"></app-loading>

<section
  class="bb-page pets-ticket-page"
  *ngIf="!contentReady"
  [class.rtl]="isAr"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="bb-page-shell pets-ticket-shell">

    <!-- Header -->
    <header class="pets-mobile-hero">
      <div class="pets-hero-copy">
        <span class="bb-eyebrow">
          {{ 'Pet Management' | transloco }}
        </span>

        <h2>
          {{ 'Pet Management' | transloco }}
        </h2>

        <p>
          {{ visiblePets.length }} / {{ allData.length }}
          {{ 'pet' | transloco }}
        </p>
      </div>

      <div class="pets-hero-icon">
        <i class="fa-solid fa-paw" aria-hidden="true"></i>
      </div>
    </header>

    <!-- Pet Form -->
    <section class="pets-form-ticket" *ngIf="clientId">

      <div class="pets-form-head">
        <div>
          <span class="bb-eyebrow">
            {{ editMode ? ('Edit' | transloco) : ('Submit' | transloco) }}
          </span>

          <h3>
            {{ editMode ? ('Edit Pet' | transloco) : ('Pet name' | transloco) }}
          </h3>
        </div>

        <button
          *ngIf="editMode"
          type="button"
          class="bb-btn bb-btn-secondary bb-btn-sm"
          (click)="resetForm()"
        >
          {{ 'Reset' | transloco }}
        </button>
      </div>

      <form [formGroup]="petForm" (ngSubmit)="savePet()">

        <div class="pets-form-grid">

          <div class="bb-field">
            <label class="bb-label" for="pet_type_mobile">
              {{ 'pet' | transloco }}
            </label>

            <select
              class="bb-select"
              id="pet_type_mobile"
              formControlName="pet_type"
              [ngClass]="{
                'is-invalid': petForm.get('pet_type')?.touched && petForm.get('pet_type')?.invalid,
                'is-valid': petForm.get('pet_type')?.touched && petForm.get('pet_type')?.valid
              }"
            >
              <option value="">-- {{ 'choose' | transloco }} --</option>
              <option value="0">{{ 'cats' | transloco }}</option>
              <option value="1">{{ 'dogs' | transloco }}</option>
              <option value="2">{{ 'birds' | transloco }}</option>
              <option value="4">{{ 'cats&dogs' | transloco }}</option>
              <option value="3">{{ 'other' | transloco }}</option>
            </select>
          </div>

          <div class="bb-field">
            <label class="bb-label" for="name_mobile">
              {{ 'Pet name' | transloco }}
            </label>

            <input
              class="bb-input"
              id="name_mobile"
              type="text"
              formControlName="name"
              placeholder="{{ 'Pet name' | transloco }}"
              [ngClass]="{
                'is-invalid': petForm.get('name')?.touched && petForm.get('name')?.invalid,
                'is-valid': petForm.get('name')?.touched && petForm.get('name')?.valid
              }"
            />
          </div>

          <div class="bb-field">
            <label class="bb-label" for="breed_mobile">
              {{ 'Breed' | transloco }}
            </label>

            <input
              class="bb-input"
              id="breed_mobile"
              type="text"
              formControlName="breed"
              placeholder="{{ 'Breed' | transloco }}"
            />
          </div>

          <div class="bb-field">
            <label class="bb-label" for="color_mobile">
              {{ 'Color' | transloco }}
            </label>

            <input
              class="bb-input"
              id="color_mobile"
              type="text"
              formControlName="color"
              placeholder="{{ 'Color' | transloco }}"
            />
          </div>

          <div class="bb-field">
            <label class="bb-label" for="special_markings_mobile">
              {{ 'Special Markings' | transloco }}
            </label>

            <input
              class="bb-input"
              id="special_markings_mobile"
              type="text"
              formControlName="special_markings"
              placeholder="{{ 'Special Markings' | transloco }}"
            />
          </div>

          <div class="bb-field">
            <label class="bb-label" for="date_of_birth_mobile">
              {{ 'Date of Birth' | transloco }}
            </label>

            <input
              class="bb-input"
              id="date_of_birth_mobile"
              type="date"
              formControlName="date_of_birth"
            />
          </div>

          <div class="bb-field">
            <label class="bb-label" for="gender_mobile">
              {{ 'Gender' | transloco }}
            </label>

            <select
              class="bb-select"
              id="gender_mobile"
              formControlName="gender"
            >
              <option value="male">{{ 'Male' | transloco }}</option>
              <option value="female">{{ 'Female' | transloco }}</option>
            </select>
          </div>

          <div class="pets-checkbox-field">
            <label class="bb-label">
              {{ 'Spayed / Neutered' | transloco }}
            </label>

            <label class="pets-switch-row">
              <input type="checkbox" formControlName="spayed_neutered" />

              <span class="pets-switch-ui"></span>

              <strong>
                {{ petForm.get('spayed_neutered')?.value ? ('Yes' | transloco) : ('no' | transloco) }}
              </strong>
            </label>
          </div>

        </div>

        <div class="pets-form-actions">
          <button
            class="bb-btn bb-btn-primary"
            type="submit"
            [disabled]="petForm.invalid"
          >
            <i class="fa-solid fa-check" aria-hidden="true"></i>
            {{ editMode ? ('Edit' | transloco) : ('Submit' | transloco) }}
          </button>

          <button
            class="bb-btn bb-btn-secondary"
            type="button"
            (click)="resetForm()"
          >
            {{ 'Reset' | transloco }}
          </button>
        </div>

      </form>
    </section>

    <!-- Pets Cards -->
    <section class="pets-ticket-list" *ngIf="!noData">

      <article
        class="pet-ticket"
        *ngFor="let element of visiblePets; trackBy: trackByPetId"
        [class.highlight-upcoming]="element?.hasUpcomingVaccination"
      >

        <!-- Top -->
        <div class="pet-ticket-top">

          <div class="pet-main-info">
            <div
              class="pet-avatar"
              [ngClass]="getPetTypeClass(element.pet_type)"
            >
              {{ getPetInitial(element) }}
            </div>

            <div class="pet-copy">
              <span>
                {{ 'pet' | transloco }}
              </span>

              <h3>
                {{ element.name || '—' }}
              </h3>

              <div class="pet-badges-row">
                <span
                  class="bb-badge pet-type-badge"
                  [ngClass]="getPetTypeClass(element.pet_type)"
                >
                  {{ getPetTypeLabel(element.pet_type) }}
                </span>

                <span
                  class="bb-badge gender-badge"
                  [ngClass]="element.gender"
                >
                  {{ element.gender === 'male' ? ('Male' | transloco) : ('Female' | transloco) }}
                </span>
              </div>
            </div>
          </div>

          <div
            class="pet-status-dot"
            [class.success]="element.spayed_neutered"
            [class.danger]="!element.spayed_neutered"
            [attr.aria-label]="'Spayed / Neutered' | transloco"
          >
            {{ element.spayed_neutered ? '✓' : '✗' }}
          </div>

        </div>

        <!-- Details -->
        <div class="pet-ticket-details">

          <div class="pet-detail-chip">
            <i class="fa-solid fa-dna" aria-hidden="true"></i>

            <span>
              {{ 'Breed' | transloco }}
            </span>

            <strong>
              {{ element.breed || '—' }}
            </strong>
          </div>

          <div class="pet-detail-chip">
            <i class="fa-solid fa-palette" aria-hidden="true"></i>

            <span>
              {{ 'Color' | transloco }}
            </span>

            <strong>
              {{ element.color || '—' }}
            </strong>
          </div>

          <div class="pet-detail-chip">
            <i class="fa-solid fa-calendar" aria-hidden="true"></i>

            <span>
              {{ 'Date of Birth' | transloco }}
            </span>

            <strong>
              {{ element.date_of_birth ? (element.date_of_birth | date: 'yyyy-MM-dd') : '—' }}
            </strong>
          </div>

          <div class="pet-detail-chip">
            <i class="fa-solid fa-shield-heart" aria-hidden="true"></i>

            <span>
              {{ 'Spayed / Neutered' | transloco }}
            </span>

            <strong>
              {{ element.spayed_neutered ? ('Yes' | transloco) : ('no' | transloco) }}
            </strong>
          </div>

        </div>

        <!-- Client -->
        <div class="pet-client-ticket" *ngIf="!clientId">
          <ng-container *ngIf="element.client; else noClient">

            <div>
              <span>
                {{ 'client' | transloco }}
              </span>

              <strong>
                {{ element.client.client_name || '—' }}
              </strong>
            </div>

            <a
              [href]="'tel:' + element.client.phone_number"
              class="pet-client-phone"
            >
              <i class="fa-solid fa-phone" aria-hidden="true"></i>
              {{ element.client.phone_number }}
            </a>

          </ng-container>

          <ng-template #noClient>
            <span class="bb-text-muted">—</span>
          </ng-template>
        </div>

        <!-- Actions -->
        <div class="pet-ticket-actions">

          <button
            *ngIf="clientId && !isSubAdmin"
            type="button"
            class="pet-action-btn pet-action-edit"
            (click)="editPet(element)"
          >
            <i class="fa-solid fa-pen" aria-hidden="true"></i>
            <span>{{ 'Edit' | transloco }}</span>
          </button>

          <button
            type="button"
            class="pet-action-btn pet-action-primary"
            (click)="vaccinations(element.id)"
          >
            <i class="fa-solid fa-syringe" aria-hidden="true"></i>
            <span>{{ 'vaccinations' | transloco }}</span>
          </button>

          <button
            *ngIf="!isSubAdmin"
            type="button"
            class="pet-action-btn pet-action-danger"
            (click)="deletePet(element.id)"
          >
            <i class="fa-solid fa-trash" aria-hidden="true"></i>
            <span>{{ 'Delete' | transloco }}</span>
          </button>

        </div>

      </article>

    </section>

    <!-- No Data -->
    <div *ngIf="noData" class="bb-empty-state bb-text-center">
      <app-nodata></app-nodata>
    </div>

    <!-- Infinite Scroll States -->
    <div class="pets-mobile-loader" *ngIf="loadingMore && !contentReady">
      <span aria-hidden="true"></span>
      <strong>{{ 'Loading' | transloco }}...</strong>
    </div>

  </div>
</section>